import React, { useState, useEffect } from "react";
import { logActivity } from "../../services/dashApiService";
import { isXamarin } from "../../services/mobileService";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { BrowserPopup } from "../BrowserPopup";

export const QuestionnairePageImagePanel = ({
	alt,
	url,
	urlLink,
	hasBorder,
	isCentered,
	hasBackground,
	classes,
	imageClasses,
	caption,
	popup,
}) => {
	const [isMobile] = useState(isXamarin());
	const [copied, setCopied] = useState(false);
	const [timer, setTimer] = useState();
	const [browser, setBrowser] = useState(false);

	const closeBrowserPopup = () => {
		setBrowser(false);
	};

	const clickHandler = () => {
		if (!urlLink) {
			return;
		}

		if (popup) {
			setBrowser({ title: caption, url: urlLink || url });
		} else if (isMobile) {
			setCopied(true);
		} else {
			window.open(urlLink, "_blank");
		}

		logActivity("link", "app - questionnaire", {
			type: "link",
			timestamp: Date.now(),
			url: urlLink,
			isMobile,
			src: "QuestionnairePageImagePanel",
		});
	};

	useEffect(() => {
		if (!copied) {
			return;
		}

		if (timer) {
			clearTimeout(timer);
		}

		const _timer = setTimeout(() => {
			setCopied(false);
			setTimer();
		}, 1000 * 1);

		setTimer(_timer);

		return () => {
			if (_timer) {
				clearTimeout(_timer);
			}
		};
	}, [copied]);

	let cls = classes || "rounded-xl";

	if (hasBorder) {
		cls += " border border-gray-400";
	}

	if (hasBackground) {
		cls += " bg-gray-100";
	}

	cls +=
		isCentered === false ? " " : " flex flex-col justify-center items-center ";

	let iCls = imageClasses + " w-1/2";

	let visitText = isMobile && !popup ? `Click to copy url` : `Click to visit`;
	let visitColour = "bg-blue-800 border-blue-400 text-white";
	if (copied) {
		visitText = "Copied to clipboard";
		visitColour = "bg-blue-200 text-gray-800 border-blue-400";
	}

	const getBody = () => {
		if (isMobile && urlLink && !popup) {
			return (
				<CopyToClipboard text={urlLink}>
					<div
						className={`${urlLink ? "cursor-pointer" : "cursor-default"}`}
						onClick={clickHandler}
					>
						<div className={`mt-4 sm:mt-4 px-4 sm:px-4 ${cls}`}>
							<img alt={`${alt || "Image"}`} src={`${url}`} className={iCls} />
						</div>
						{caption && (
							<div
								className={`mt-1 px-4 sm:px-4 text-gray-600 text-center text-sm`}
								dangerouslySetInnerHTML={{ __html: `${caption}` }}
							></div>
						)}
						<div className="">
							<span
								className={`text-sm w-content px-2 border rounded bottom-0 mt-0.5 ${visitColour}`}
							>
								{visitText}
							</span>
						</div>
					</div>
				</CopyToClipboard>
			);
		} else {
			return (
				<div
					className={`${urlLink ? "cursor-pointer" : "cursor-default"}`}
					onClick={clickHandler}
				>
					<div className={`mt-4 sm:mt-4 px-4 sm:px-4 ${cls}`}>
						<img alt={`${alt || "Image"}`} src={`${url}`} className={iCls} />
					</div>
					{caption && (
						<div
							className={`mt-1 px-4 sm:px-4 text-gray-600 text-center text-sm`}
							dangerouslySetInnerHTML={{ __html: `${caption}` }}
						></div>
					)}
					{urlLink && (
						<div className="">
							<span
								className={`text-sm w-content px-2 border rounded bottom-0 mt-0.5 ${visitColour}`}
							>
								{visitText}
							</span>
						</div>
					)}
				</div>
			);
		}
	};

	return (
		<>
			{getBody()}
			<BrowserPopup
				title={browser?.title}
				url={browser?.url}
				show={browser ? true : false}
				onClose={closeBrowserPopup}
			/>
		</>
	);
};
